//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamAdeInstitucionalniPredpokladDesigner.ts             </Name>
//    <Description>                                                             </Description>
//    <Author>      JKLUSACEK                                                      </Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-10-21                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.16.5
//AdtGeneratorConfig:[ T:(srvstip) GID:(Web.Set.Des.Ts) V1:(ixs_tip,nazev,aktivita,ixs_typ,dat_zmena,zmenu_prov,k_v,rezim_real,priz_nevyzad) V2:() K1:() K2:() K3:() ]


/// <reference path="../../Base/SeznamBase.ts" />

namespace Gordic.Adm.WebControls {

    /**
     * SeznamAdeInstitucionalniPredpokladDesigner
     * 
     * @author JKLUSACEK
     * @since 482.1.0.119
     */
    export class SeznamAdeInstitucionalniPredpokladDesigner extends SeznamBase {

        /** z detail okna p�edan� atribut pro filtr seznamu */
            /** PK - ixs_tip */
            public ixs_tip: string;

        /** isl view gridu */
        view: Gordic.Isl.View<Gordic.AdmIsl.Interface.GAdeInstitucionalniPredpokladListDto>;

        /** vytvo�it formul�� filtru - panel */
        static createFilter(that: GContentType<SeznamAdeInstitucionalniPredpokladDesigner>, ixs_tip: string  ): JQuery<HTMLElement> {
            // vytvorim form a na nem policka
            let v_form = this.createFilterForm(that, ixs_tip);
            // vytvorim panel a umistim jej do hlavniho DIVu
            let v_filter = SeznamBase.createFilterBase(that, v_form, true, this.applyAction );

            //v_filter.gfilterpanel("applyFilter");         // toto vede k okam�it�mu na�ten� dat do seznamu podle nastaven�ho filtru

            return (v_filter);
        } // createFilter

        /** vytvo�it formul�� filtru - vytvo�� tam filtra�n� pol��ka */
        static createFilterForm(that: GContentType<SeznamAdeInstitucionalniPredpokladDesigner>, ixs_tip: string ): Forms.Form {

            // vytvo��m form
            var v_filterForm = SeznamBase.createFilterFormBase(that);

            // p�id�m do n�j pol��ka

            return v_filterForm;
        } // createFilterForm

        static applyAction(that: GContentType<SeznamAdeInstitucionalniPredpokladDesigner>, ev, ctx): any {
            var filterObj = {
            }
            that.view = new Gordic.Isl.View(that.isl.AdeInstitucionalniPredpoklad.list({ filters: filterObj }));
            that.grid.ggrid("setData", that.view);
        }

        /**
         * SeznamAdeInstitucionalniPredpokladDesignerInit
         * 
         * @param {GContentType<SeznamAdeInstitucionalniPredpokladDesigner>} that
         */
        static SeznamAdeInstitucionalniPredpokladDesignerInit(that: GContentType<SeznamAdeInstitucionalniPredpokladDesigner>, ixs_tip: string, withFilterPanel: boolean) {
            this.SeznamBaseInit(that);
            if (withFilterPanel == true)
                that.filter = this.createFilter(that, ixs_tip);
            that.gridFormat = this.createGridFormatByDataListDescription(that);
            that.gridSearchColumns = this.createGridSearchColumnsByDataListDescription(that)
            this.LoadData(that, ixs_tip);
        } // SeznamAdeInstitucionalniPredpokladDesignerInit

        static LoadData(that: GContentType<SeznamAdeInstitucionalniPredpokladDesigner>, ixs_tip: string) {
            var filterObj: any = {}
            that.view = new Gordic.Isl.View(that.isl.AdeInstitucionalniPredpoklad.list({ filters: filterObj }), { filterPanel: that.filter, startEmpty: false, });       // propojen� ovl�dac�ho prvku gridu se zdrojem dat - a s filter panelem
        }

    }
}
